import { render, staticRenderFns } from "./Game_Template.vue?vue&type=template&id=da9c3264&scoped=true&"
import script from "./Game_Template.vue?vue&type=script&lang=js&"
export * from "./Game_Template.vue?vue&type=script&lang=js&"
import style0 from "./Game_Template.vue?vue&type=style&index=0&id=da9c3264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9c3264",
  null
  
)

export default component.exports